'use client';

import React, { memo } from 'react';
import { X } from 'lucide-react';

import { Button } from '@repo/ui/components/ui/button';

interface ArticleCardAnalysisHeaderProps {
  onClose: () => void;
}

const PureArticleCardAnalysisHeader: React.FC<
  ArticleCardAnalysisHeaderProps
> = ({ onClose }) => {
  return (
    <div className="mt-0! absolute z-1 left-1.5 top-1.5 @cred-sm:left-2 @cred-sm:top-2 @cred-lg:left-1 @cred-lg:top-1.5 @cred-xl:left-2.5 @cred-xl:top-2.5">
      <Button
        variant="ghost"
        size="icon"
        onClick={onClose}
        className="size-6 bg-transparent p-0 text-white cursor-pointer hover:bg-white/10 [&_svg]:size-5"
      >
        <X />
        <span className="sr-only">Close analysis</span>
      </Button>
    </div>
  );
};
export const ArticleCardAnalysisHeader = memo(PureArticleCardAnalysisHeader);
